import { render, staticRenderFns } from "./TransfersList.vue?vue&type=template&id=e649a996&scoped=true&"
import script from "./TransfersList.vue?vue&type=script&lang=js&"
export * from "./TransfersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e649a996",
  null
  
)

export default component.exports